export default __webpack_public_path__ + "static/media/benefit_icon_views.331b2653.svg";